/* eslint-disable */
import React, { useState, useEffect } from 'react';
import useFullScreen from '../../Hooks/useFullScreen';
import useTranslation from '../../Hooks/useTranslation';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import useLeaveTab from '../../Hooks/useFocus';
import graphql from '../../Api/graphql';
//import nd from '../../Config/Environment';
const initialTasks = [
  {
    id: '1',
    text: 'React.js',
  },
  {
    id: '2',
    text: 'HTML/CSS',
  },
  {
    id: '3',
    text: 'AWS',
  },
  {
    id: '4',
    text: 'JavaScript',
  },
];

export default function index() {
  useEffect(() => {
    graphql('Users', 'id email company{ name }', 'query').then(data => {});
  }, []);
  /* const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const { openFullScreen, toggleFullScreen, closeFullScreen } =
    useFullScreen(handleClickOpen);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md')); */

  //return {
  /* <div>
      <Button variant="outlined" onClick={toggleFullScreen}>
        Open responsive dialog
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Si sales del modo pantalla completa se dara por terminado el examen,
            quieres salir del modo pantalla completa
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              closeFullScreen();
              handleClose();
            }}
          >
            Si quiero salir
          </Button>
          <Button
            onClick={() => {
              openFullScreen();
              handleClose();
            }}
            autoFocus
          >
            desep quedarme en el examen
          </Button>
        </DialogActions>
      </Dialog>
    </div> */
  //};

  const { language, setLanguage, setFallbackLanguage, t } = useTranslation();
  const hola = 'jojo';

  return (
    <>
      <div>Hola 2</div>
      <div>{language}</div>
      <div>{t('Test.hi', ['misael', 'mexicali'])}</div>
      <div>{t('Test.bye')}</div>
      <div>{t('Test.nested.value')}</div>
      <button onClick={() => setLanguage('sp')}>Change To Spanish</button>
      <button onClick={() => setLanguage('en')}>Change To English</button>
      <button onClick={() => setFallbackLanguage('sp')}>Change FB Lang</button>
    </>
  );
}

/* import { Provider } from 'react-redux';
import store from '../../Redux/store';
import Jugadores from './Jugadores';
import EquipoSeleccionado from './EquipoSeleccionado';
export default function index() {
  return (
    <Provider store={store}>
      <Jugadores></Jugadores>
      <EquipoSeleccionado></EquipoSeleccionado>
    </Provider>
  );
} */
